define('frontend-common-components/utils/i18nMessageLoader',[],function () {
    return function (messageBundle) {
        return function (key) {
            if (!key) {
                return key;
            }

            var value = messageBundle;
            var keySegments = key.split('.');

            for (var x = 0 ; x < keySegments.length ; x++) {
                value = value[keySegments[x]];

                if (typeof value === 'undefined') {
                    return key;
                }
            }

            return value;
        };
    };
});

